import { useQuery } from "@apollo/client";

import { gql } from "~/__generated__";

const COMMON_JOB_QUEUE_GET_JOB_BY_ID = gql(`
query CommonJobQueueGetJobById($id: String!, $type: String!) {
    commonJobQueueGetJobById(id: $id, type: $type) {
        id
        status
        worker
        message
        output
    }
}
`);

export default function useCommonJobQueueGetJobById(id: string | undefined, type: string) {
    const queryParams = id !== undefined ? { variables: { id, type } } : { skip: true };
    const { data, loading, error, startPolling, stopPolling } = useQuery(COMMON_JOB_QUEUE_GET_JOB_BY_ID, queryParams);

    return {
        loading,
        error,
        data: data?.commonJobQueueGetJobById,
        startPolling,
        stopPolling,
    };
}
